export const routes = (prefix = `registration`) => [
    {
        path: `/${prefix}/patient-management`,
        name: `${prefix}.patient-management.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patient-management.index`,
                PageDescription: "Patient Management - Create, modify and create visit",
            },
        },
    },
    {
        path: `/${prefix}/patient-management/create`,
        name: `${prefix}.patient-management.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patient-management.create`,
                PageDescription: "Patient Management - Create patient",
            },
        },
    },
    {
        path: `/${prefix}/patient-management/:patientID/edit`,
        name: `${prefix}.patient-management.edit`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patient-management.edit`,
                PageDescription: "Patient Management - Edit patient",
            },
        },
    },
    {
        path: `/${prefix}/patient-management/print/:patientID`,
        name: `${prefix}.patient-management.print`,
        component: () => import('./prints/PatientDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patient-management.print`,
                PageDescription: "Patient Management - Print patient details",
            },
        },
    },
];
